// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-row{
    display:flex;
    flex-wrap:wrap;
}

.news-card-wrapper{
    margin-bottom:30px;
    display:flex;
}

.news-card{
    background:#fff;
    border:1px solid #e8e8e8;
    border-radius:8px;
    padding:20px;
    width:100%;
    display:flex;
    flex-direction:column;
    min-height:340px;
    transition:all .3s ease;
    box-shadow:0 2px 8px rgba(0,0,0,.08);
}

.news-card:hover{
    transform:translateY(-5px);
    box-shadow:0 8px 20px rgba(0,0,0,.15);
}

.news-meta{
    font-size:13px;
    color:#777;
    margin-bottom:10px;
}

.primaryc{
    color:#0066cc;
    font-weight:bold;
}

/* .news-title{
    margin:0 0 15px;
    font-size:22px;
    line-height:30px;
    height:90px;          
    overflow:hidden;
} */

.news-title a{
    color:#222;
    text-decoration:none;
}

.news-title a:hover{
    color:#0066cc;
}

/* .news-desc{
    color:#666;
    font-size:15px;
    line-height:24px;
    height:96px;         
    overflow:hidden;
    text-overflow:ellipsis;
} */

.read-more{
    margin-top:auto;
    display:inline-block;
    color:#0066cc;
    font-weight:bold;
    text-decoration:none;
}

.read-more:hover{
    text-decoration:underline;
}

.news-title{
    display:-webkit-box;
    -webkit-line-clamp:3;
    -webkit-box-orient:vertical;
    overflow:hidden;
    height:auto;
    min-height:90px;
}

.news-desc{
    display:-webkit-box;
    -webkit-line-clamp:4;
    -webkit-box-orient:vertical;
    overflow:hidden;
    min-height:96px;
}`, "",{"version":3,"sources":["webpack://./src/components/news.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,iBAAiB;IACjB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,qBAAqB;IACrB,gBAAgB;IAChB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;;;;;;GAMG;;AAEH;IACI,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;;;;;;;GAOG;;AAEH;IACI,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,2BAA2B;IAC3B,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,2BAA2B;IAC3B,eAAe;IACf,eAAe;AACnB","sourcesContent":[".news-row{\r\n    display:flex;\r\n    flex-wrap:wrap;\r\n}\r\n\r\n.news-card-wrapper{\r\n    margin-bottom:30px;\r\n    display:flex;\r\n}\r\n\r\n.news-card{\r\n    background:#fff;\r\n    border:1px solid #e8e8e8;\r\n    border-radius:8px;\r\n    padding:20px;\r\n    width:100%;\r\n    display:flex;\r\n    flex-direction:column;\r\n    min-height:340px;\r\n    transition:all .3s ease;\r\n    box-shadow:0 2px 8px rgba(0,0,0,.08);\r\n}\r\n\r\n.news-card:hover{\r\n    transform:translateY(-5px);\r\n    box-shadow:0 8px 20px rgba(0,0,0,.15);\r\n}\r\n\r\n.news-meta{\r\n    font-size:13px;\r\n    color:#777;\r\n    margin-bottom:10px;\r\n}\r\n\r\n.primaryc{\r\n    color:#0066cc;\r\n    font-weight:bold;\r\n}\r\n\r\n/* .news-title{\r\n    margin:0 0 15px;\r\n    font-size:22px;\r\n    line-height:30px;\r\n    height:90px;          \r\n    overflow:hidden;\r\n} */\r\n\r\n.news-title a{\r\n    color:#222;\r\n    text-decoration:none;\r\n}\r\n\r\n.news-title a:hover{\r\n    color:#0066cc;\r\n}\r\n\r\n/* .news-desc{\r\n    color:#666;\r\n    font-size:15px;\r\n    line-height:24px;\r\n    height:96px;         \r\n    overflow:hidden;\r\n    text-overflow:ellipsis;\r\n} */\r\n\r\n.read-more{\r\n    margin-top:auto;\r\n    display:inline-block;\r\n    color:#0066cc;\r\n    font-weight:bold;\r\n    text-decoration:none;\r\n}\r\n\r\n.read-more:hover{\r\n    text-decoration:underline;\r\n}\r\n\r\n.news-title{\r\n    display:-webkit-box;\r\n    -webkit-line-clamp:3;\r\n    -webkit-box-orient:vertical;\r\n    overflow:hidden;\r\n    height:auto;\r\n    min-height:90px;\r\n}\r\n\r\n.news-desc{\r\n    display:-webkit-box;\r\n    -webkit-line-clamp:4;\r\n    -webkit-box-orient:vertical;\r\n    overflow:hidden;\r\n    min-height:96px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
